import script from "./room-card.vue?vue&type=script&setup=true&lang=js"
export * from "./room-card.vue?vue&type=script&setup=true&lang=js"

import "./room-card.vue?vue&type=style&index=0&id=04a9ff88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a9ff88"]])

export default __exports__